import script from "./OCriarRelatorioAtividades.vue?vue&type=script&lang=ts&setup=true"
export * from "./OCriarRelatorioAtividades.vue?vue&type=script&lang=ts&setup=true"

import "./OCriarRelatorioAtividades.vue?vue&type=style&index=0&id=1b728793&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b728793"]])

export default __exports__